import { useField } from 'formik';
import { Flex, Icon, Switch } from '@chakra-ui/react';
import { Stars03 } from '@kula-ai/icons/outline/Stars03';
import { KText } from '@/ui-library/components/text';

export const SchNoteTakerField = ({ page, updateSharedData }) => {
  const [field, , helpers] = useField('note_taker_enabled');
  const [{ value: mandatoryValue }] = useField('note_taker_mandatory');
  const { setValue } = helpers;
  const { value } = field;

  const onToggle = (event) => {
    const { checked } = event.target;
    setValue(checked);
    // Store in shared data so it's available when switching interviews
    if (updateSharedData) {
      updateSharedData('note_taker_enabled', checked);
    }
  };

  return (
    <Flex
      bg="#F8F7FA"
      borderRadius="12px"
      p="18px 16px"
      gap="10px"
      mx={page === 'add_interview' ? '24px' : '0px'}
      id="note_taker_enabled"
    >
      <Flex flexDir="column" gap="10px" w="100%">
        <Flex justifyContent="space-between" alignItems="center">
          <Flex gap="10px" alignItems="center">
            <Icon as={Stars03} w="20px" h="20px" color="primary-700" />
            <KText size="sm-semi-bold" color="primary-700">
              Enable AI notetaker?
            </KText>
          </Flex>
          <Switch
            className={`ats-switch-toogle ${value ? 'active' : ''}`}
            colorScheme="ats-primary"
            cursor="pointer"
            isChecked={value}
            disabled={mandatoryValue}
            onChange={onToggle}
          />
        </Flex>
        <KText size="sm-regular" color="primary-900" pb="20px">
          The AI Notetaker automatically captures key points and summaries
          during meetings. It organizes and highlights information for easy
          review and follow-up.
        </KText>
      </Flex>
    </Flex>
  );
};
